import Icon from '../components/Icon.vue'

Icon.register({
  'birthday-cake': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 384C420 384 416.7 352 373.5 352 330.1 352 326.7 384 298.8 384 271.1 384 267.3 352 224 352 181.2 352 176.8 384 149.5 384 121.4 384 118.3 352 74.8 352 31.2 352 28.1 384 0 384V304C0 277.5 21.5 256 48 256H64V112H128V256H192V112H256V256H320V112H384V256H400C426.5 256 448 277.5 448 304V384zM448 512H0V416C43.4 416 46.8 384 74.8 384 102.7 384 106 416 149.5 416 192.3 416 196.7 384 224 384 252.1 384 255.2 416 298.8 416 342.1 416 345.5 384 373.5 384 401 384 404.8 416 448 416V512zM96 96C78.3 96 64 81.8 64 64 64 33 96 41 96 0 108 0 128 29.5 128 56S113.8 96 96 96zM224 96C206.3 96 192 81.8 192 64 192 33 224 41 224 0 236 0 256 29.5 256 56S241.8 96 224 96zM352 96C334.3 96 320 81.8 320 64 320 33 352 41 352 0 364 0 384 29.5 384 56S369.8 96 352 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/birthday-cake.js
// module id = ecIV
// module chunks = 144